// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2082":"8d8fe7b8aa1f2530","2546":"49832929e68a974c","4604":"ebd86213f3afd6fc","5205":"d6e2ca66c1fde648"}[chunkId] + ".css";
};